import React from 'react'
import View from './View'
import Text from './TextNew'
import timePassedSinceDate from 'src/helpers/timePassedSinceDate'
import { useTranslation } from 'react-i18next'

interface Props {
  publishedAt: string
}
const PublishedTimeAgo = ({ publishedAt }: Props): JSX.Element => {
  const { t } = useTranslation()

  return (
    <View>
      <Text className="text-l inline">{t('single_offer.added')}</Text>
      <Text className="text-l font-Bold inline"> {timePassedSinceDate(publishedAt)}</Text>
      <Text className="text-l inline"> {t('single_offer.ago')}</Text>
    </View>
  )
}

export default PublishedTimeAgo
